import { QuestionCircleOutlined } from '@ant-design/icons'
import { Empty, message, Modal, Select } from 'antd'
import pickBy from 'lodash/pickBy'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import {
  HistoryOutlineIcon,
  Pen2OutlineIcon,
  TrashBin2OutlineIcon,
} from '../../components/AppIcon'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import ManagementAssetWarehouseHistory from './ManagementAssetWarehouseHistory'
import ManagementAssetWarehouseUpdate from './ManagementAssetWarehouseUpdate'

const { Option } = Select

const { confirm } = Modal

const ManagementAssetWarehouseTable = props => {
  const {
    selectPeopleStore,
    authenticationStore,
    managementAssetWarehouseStore,
    selectedRowKeys,
    setSelectedRowKeys,
  } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [isVisibleHistoryModal, setIsVisibleHistoryModal] = useState(false)
  const [selectedTemplateId, setSelectedTemplateId] = useState(null)
  const [selectedHistoryId, setSelectedHistoryId] = useState(null)
  const [historyAssetName, setHistoryAssetName] = useState('')

  const { companyCode } = selectPeopleStore
  const {
    managementAssetWarehouseList,
    totalCount,
  } = managementAssetWarehouseStore

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  useEffect(() => {
    ;(async () => {
      if (companyCode) {
        try {
          await selectPeopleStore.getDepartmentWithUsers()
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const loadManagerInventoryList = async () => {
    try {
      setIsLoading(true)
      const queryParams = {
        page: queryStringParse?.page || 0,
        size: queryStringParse?.size || 10,
        asset_type_id: queryStringParse?.asset_type_id || null,
        asset_name: queryStringParse?.asset_name || null,
        createdAt: queryStringParse?.createdAt || undefined,
      }
      const formattedQueryPayload = pickBy(queryParams, v => v != null)
      await managementAssetWarehouseStore.getManagementAssetWarehousetList(
        queryString.stringify(formattedQueryPayload)
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleOpenUpdateModal = id => {
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
  }

  const handleOpenHistoryModal = record => {
    setIsVisibleHistoryModal(true)
    setSelectedHistoryId(record.id)
    setHistoryAssetName(record.asset_name)
  }

  const handleCancelHistoryModal = () => {
    setIsVisibleHistoryModal(false)
  }

  const handleDelete = async code => {
    try {
      setIsLoading(true)
      await managementAssetWarehouseStore.delete(code)
      await loadManagerInventoryList()
      message.success('Đã xóa!')
    } catch (err) {
      console.log(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
  }

  const showConfirm = (e, code) => {
    e.stopPropagation()
    setIsVisibleUpdateModal(false)
    confirm({
      title: 'Bạn có chắc chắn muốn xóa Tài sản này ?',
      icon: (
        <QuestionCircleOutlined
          style={{
            color: 'red',
          }}
        />
      ),
      okText: 'Xóa',
      cancelText: 'Không',
      okType: 'danger',
      onOk: async () => {
        await handleDelete(code)
      },
    })
  }

  const handleChangePageInventoryAssetLeave = (page, pageSize) => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: page - 1,
        size: pageSize,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/manager-inventory/inventory-asset?${queryStringStringify}`)
  }

  const tableColumns = [
    {
      title: 'Loại văn phòng phẩm',
      width: 180,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.asset_type.is_deleted === false
            ? record.asset_type?.description
            : null}
        </p>
      ),
    },
    {
      title: 'Tên văn phòng phẩm',
      width: 200,
      ellipsis: true,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record.asset_name}
        </p>
      ),
    },

    {
      title: 'Đơn vị tính',
      width: 150,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.asset_unit_name}
        </p>
      ),
    },
    {
      title: 'Thuế',
      width: 150,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.tax ? `${record?.tax}%` : '----'}
        </p>
      ),
    },
    {
      title: 'Đơn giá trước thuế',
      width: 150,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.price
            ? parseFloat(record?.price).toLocaleString('vi-VN')
            : '----'}
        </p>
      ),
    },
    {
      title: 'Đơn giá sau thuế',
      width: 150,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.total_money
            ? parseFloat(record?.total_money).toLocaleString('vi-VN')
            : '----'}
        </p>
      ),
    },
    {
      title: 'Số lượng trong kho',
      width: 150,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.amount}
        </p>
      ),
    },
    {
      title: 'Ngày tạo',
      width: 150,
      render: record => {
        const date = new Date(record?.create_at || 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')

        const formattedDate = `${day}/${month}/${year}`
        return (
          <p
            style={{
              marginBottom: '0px',
            }}>
            {formattedDate}
          </p>
        )
      },
    },
    {
      title: 'Thao tác',
      width: 120,
      align: 'center',
      fixed: 'right',
      //ignore onRow event
      onCell: record => {
        return {
          onClick: event => {
            event.stopPropagation()
          },
        }
      },
      render: record => (
        <div>
          <HistoryOutlineIcon
            title="Lịch sử"
            style={{
              marginRight: '8px',
              width: 16,
              height: 16,
              cursor: 'pointer',
            }}
            type={'vertical'}
            onClick={() => handleOpenHistoryModal(record)}
          />
          <Pen2OutlineIcon
            title="Chỉnh sửa"
            style={{
              marginRight: '8px',
              width: 16,
              height: 16,
              cursor: 'pointer',
            }}
            type={'vertical'}
            onClick={() => handleOpenUpdateModal(record.id)}
          />
          <TrashBin2OutlineIcon
            title="Xóa"
            style={{
              color: '#fc0000',
              width: 16,
              height: 16,
              cursor: 'pointer',
            }}
            onClick={e => showConfirm(e, record.id)}
          />
        </div>
      ),
    },
  ]

  const onSelectChange = newSelectedRowKeys => {
    if (newSelectedRowKeys.length > 1) {
      setSelectedRowKeys([newSelectedRowKeys[1]])
    } else {
      setSelectedRowKeys(newSelectedRowKeys)
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
  }

  useEffect(() => {
    void managementAssetWarehouseStore.getManagementAssetWarehouseAssetTypes()
  }, [])

  useEffect(() => {
    setSelectedRowKeys(null)
    void loadManagerInventoryList()
  }, [queryStringParse])

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  return (
    <>
      <AppTable
        // @ts-ignore
        rowSelection={rowSelection}
        rowKey={record => record.id}
        dataSource={managementAssetWarehouseList}
        // @ts-ignore
        columns={tableColumns}
        pagination={false}
        onRow={record => ({
          onClick: () => handleOpenUpdateModal(record.id),
        })}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />
      <AppTablePagination
        current={Number(queryStringParse?.page || 0) + 1}
        pageSize={Number(queryStringParse?.size || 10)}
        total={totalCount}
        onChange={handleChangePageInventoryAssetLeave}
      />

      <Modal
        width={700}
        wrapClassName="custom-modal-wrapper"
        title={'Chỉnh sửa tài sản'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ManagementAssetWarehouseUpdate
            onCancel={handleCancelUpdateModal}
            templateId={selectedTemplateId}
          />
        )}
      </Modal>
      <Modal
        width={700}
        wrapClassName="custom-modal-wrapper"
        title={'Lịch sử'}
        visible={isVisibleHistoryModal}
        maskClosable={false}
        onCancel={handleCancelHistoryModal}
        footer={null}
        destroyOnClose>
        {isVisibleHistoryModal && (
          <ManagementAssetWarehouseHistory
            selectedHistoryId={selectedHistoryId}
            historyAssetName={historyAssetName}
            onCancel={handleCancelHistoryModal}
          />
        )}
      </Modal>
    </>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(ManagementAssetWarehouseTable))
